import Component from '../abstracts/Component';

export default class DataLinkHrefComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-link-href]',
    };
  }


  constructor() {
    super();
  }
  isExternal(linkEl){
        let isExternalDataAttr  = linkEl.dataset.isExternalLink;

        if(isExternalDataAttr && isExternalDataAttr === 'true'){
            isExternalDataAttr.toLowerCase().trim();
            return true;
        }else{
            return false;
        }
  }
  linkHandler(linkEl){
      let formatedHref = linkEl.dataset.linkHref.trim();
      if(formatedHref.length>0){
          linkEl.addEventListener('click', ()=>{
            if (this.isExternal(linkEl)) {
              window.open(formatedHref, '_blank', 'noopener noreferrer');
            } else {
              window.open(formatedHref, '_self');
            }
          })
      }else{
          return;
      }
  }
  initDataLinks(){
      let everyLink = document.querySelectorAll(this.SELECTORS.main);
        for (let link of everyLink){
            this.linkHandler(link);
        }
  }
    render() {
        super.render();
        if(document.querySelector(this.SELECTORS.main)){
            this.initDataLinks();
        }
    }


}
